if (!customElements.get('gltheaa-email-modal')) {
  const STORAGE_KEY = 'gltheaa-email-modal-dismissed';
  const COOKIE_NAME = 'gltheaa_email_modal';

  class GltheaaEmailModal extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      this.designMode = this.dataset.designMode === 'true';
      this.delay = Number(this.dataset.delay || 0);
      this.dismissDays = Number(this.dataset.dismissDays);
      if (!Number.isFinite(this.dismissDays)) this.dismissDays = 7;
      this.subscribed = Boolean(this.querySelector('[data-email-modal-success]'));
      this.forceOpen = Boolean(this.querySelector('[data-email-modal-force-open]'));
      this.scrollY = window.scrollY;

      if (!this.designMode && this.parentElement !== document.body) {
        document.body.prepend(this);
      }

      this.querySelectorAll('[data-email-modal-close]').forEach((button) => {
        button.addEventListener('mousedown', (event) => event.preventDefault());
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.dismiss();
        });
      });

      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.dismiss();
      });

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dismiss();
      });

      this.dialog.addEventListener('close', () => this.pinScroll(this.scrollY));

      if (this.dismissDays <= 0 && !this.subscribed) this.forget();

      if (this.forceOpen || this.designMode) {
        this.open(true);
        return;
      }

      if (this.isDismissed()) return;

      this.timer = window.setTimeout(() => this.open(false), this.delay * 1000);
    }

    readUntil() {
      let until = 0;

      try {
        until = Number(window.localStorage.getItem(STORAGE_KEY) || 0);
      } catch (error) {
        until = 0;
      }

      const match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=(\\d+)'));
      const cookieUntil = match ? Number(match[1]) : 0;
      return Math.max(Number.isFinite(until) ? until : 0, Number.isFinite(cookieUntil) ? cookieUntil : 0);
    }

    isDismissed() {
      if (this.dismissDays <= 0 && !this.subscribed) return false;
      return this.readUntil() > Date.now();
    }

    forget() {
      try {
        window.localStorage.removeItem(STORAGE_KEY);
      } catch (error) {
        // Storage can be blocked. The cookie below still clears the close.
      }

      document.cookie = COOKIE_NAME + '=; path=/; max-age=0; SameSite=Lax';
    }

    remember(days) {
      if (this.designMode || !Number.isFinite(days) || days <= 0) return;

      const until = Date.now() + days * 24 * 60 * 60 * 1000;
      const maxAge = Math.max(1, Math.floor((until - Date.now()) / 1000));

      try {
        window.localStorage.setItem(STORAGE_KEY, String(until));
      } catch (error) {
        // Storage can be blocked. The cookie below still records the close.
      }

      document.cookie = COOKIE_NAME + '=' + until + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
    }

    open(force) {
      if (!this.dialog || this.dialog.open) return;
      if (!force && this.isDismissed()) return;

      const y = window.scrollY;
      this.scrollY = y;
      this.dialog.showModal();
      this.pinScroll(y);
    }

    pinScroll(y) {
      const top = y || 0;
      const pin = () => {
        if (Math.abs(window.scrollY - top) > 1) window.scrollTo(0, top);
      };

      pin();
      window.requestAnimationFrame(pin);
      window.setTimeout(pin, 0);
      window.setTimeout(pin, 50);
      window.setTimeout(pin, 150);
      window.setTimeout(pin, 300);
    }

    dismiss() {
      if (this.closing) return;
      this.closing = true;
      window.clearTimeout(this.timer);
      const y = window.scrollY;
      this.scrollY = y;
      const days = this.subscribed ? Math.max(this.dismissDays, 365) : this.dismissDays;
      if (days <= 0) this.forget();
      else this.remember(days);

      const active = document.activeElement;
      if (active instanceof HTMLElement) active.blur();

      const finish = () => {
        this.dialog.classList.remove('is-closing');
        if (this.dialog.open) this.dialog.close();
        this.pinScroll(y);
        this.closing = false;
      };
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!this.dialog.open || reduceMotion) {
        finish();
        return;
      }

      this.dialog.classList.add('is-closing');
      window.setTimeout(finish, 250);
    }
  }

  customElements.define('gltheaa-email-modal', GltheaaEmailModal);
}
